import Table from "react-bootstrap/Table";
import React, { useState, useEffect } from "react";
const moment = require("moment");
import "../../main.css";
import CallIcon from "assets/svgs/table_call";
import CallCut from "assets/svgs/call_cut.js";
import customerChatUseStore from "./store";
import Loader from "modules/Loader";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import Toaster from "modules/common/react_toaster/Toaster";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Placeholder } from "react-bootstrap";
import NoData from "assets/svgs/no_data/NoData";
import { getFormattedDate } from "modules/utilities/utility";
import { useBookingData } from "modules/nextcall/store";

function CustomerChatTable({ tableData, isLoading, error }) {
  const { fetchCall } = customerChatUseStore();
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);
  const [clickedIndexes, setClickedIndexes] = useState([]);
  const [sortedData, setSortedData] = useState(tableData);
  const [call, setCall] = useState(null);
  const [phone, setPhone] = useState(null);
  const [callObj, setCallObj] = useState({});
  const { setToaster } = useToast();
  const { sortedEngagementFirstElemId } = useBookingData();

  useEffect(() => {
    setSortedData([...tableData.sort((a, b) => moment(b.createdAt) - moment(a.createdAt))]);
  }, [tableData]);

  useEffect(() => {
    if (!call) {
      return;
    } else {
      fetchCall(callObj);
    }
  }, [call]);

  const handleSortCreatedDate = () => {
    if (count === 3) {
      setCount(0);
    }
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setSortedData([
        ...tableData.sort((a, b) => moment(a.updatedAt) - moment(b.updatedAt)),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setSortedData([
        ...tableData.sort((a, b) => moment(b.updatedAt) - moment(a.updatedAt)),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(3);
      setSortedData([...tableData]);
    }
  };

  const handleCall = (index, item) => {
    setCallObj({
      phone_number: item?.user?.[0]?.phone_number,
      case_id: item?.user?.[0]?.case_id,
      note: {},
      engagement_id: sortedEngagementFirstElemId
    });

    if (!clickedIndexes.includes(index)) {
      setClickedIndexes([...clickedIndexes, index]);
      setCall(index + 1);
      setPhone(item?.chat_meta?.user?.phone_number);
      setToaster(
        "Customer Call",
        item?.chat_meta?.user?.phone_number,
        "success"
      );
    }
  };

  const tableHeader = ["Customer Name", "Type", "Sender"];
  const headStyle = { minWidth: "14rem", position: "sticky" };
  const headStyleHeader = {
    minWidth: "14rem",
    position: "sticky",
    top: 0,
    zIndex: "4",
  };
  const headStyleHeaderStyle = {
    minWidth: "14rem",
    position: "sticky",
    top: 0,
    zIndex: "4",
    backgroundColor: "rgb(234,240,252)",
    borderRadius: "10px",
  };

  return (
    <>
      <div
        className=" rounded mt-4 scrollable-table-feed w-100"
        style={{ minHeight: "20vh" }}
      >
        <table className="table px-2 rounded table-hover">
          <thead
            className="pb-0  rounded-top text-secondary"
            style={headStyleHeaderStyle}
          >
            <tr
              style={{
                background: "#F9FAFD",
                position: "sticky",
                top: 0,
                zIndex: "5",
              }}
              className="border rounded-top d-flex"
            >
              {tableHeader.map((header) => (
                <th
                  className="table-column flex-1 text-black fw-bold mt-2 fs-1 align-top"
                  style={headStyleHeader}
                  key={header}
                >
                  {header}
                </th>
              ))}
              <th
                style={headStyleHeader}
                className="flex-1 vertical-align-top text-black cursor-pointer fw-bold  fs-1"
                onClick={handleSortCreatedDate}
              >
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      style={{ position: "fixed" }}
                      id="overlay-trigger-example"
                    >
                      {count == 0 ? (
                        <span className="fs-1">Click to sort ascending</span>
                      ) : count == 1 ? (
                        <span className="fs-1">Click to sort Descending</span>
                      ) : (
                        <span className="fs-1">Click to cancel sort</span>
                      )}
                    </Tooltip>
                  }
                >
                  <span>Created Date</span>
                </OverlayTrigger>
                <div
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    paddingLeft: "1rem",
                  }}
                >
                  <div
                    className={
                      opa === ""
                        ? "opacity-100"
                        : opa === "asc"
                        ? "opacity-50"
                        : "opacity-100"
                    }
                  >
                    <AscendingLogoGrey />
                  </div>
                  <div
                    className={
                      opa === ""
                        ? "opacity-100 mt-n2"
                        : opa === "dsc"
                        ? "opacity-50 mt-n2"
                        : "opacity-100 mt-n2"
                    }
                  >
                    <DescendingLogoGrey />
                  </div>
                </div>
              </th>

              <th
                style={headStyleHeader}
                className="flex-1 align-top text-center mt-2 fs-1 text-black fw-bold"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody className="w-100 rounded-bottom">
            {isLoading ? (
              <tr>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                </Placeholder>
              </tr>
            ) : tableData?.length !== 0 &&
              isLoading === false &&
              Array.isArray(sortedData) &&
              sortedData.length > 0 ? (
              tableData?.map((item, index) => {
                const isClicked = clickedIndexes.includes(index);
                return (
                  <tr
                    id="table-row-value"
                    className={`d-flex border border-top-0 bg-white ${
                      index === tableData.length - 1 ? `rounded-bottom` : ``
                    }`}
                    key={item?._id}
                  >
                    <td
                      className="flex-1 m-0 text-primary fw-bold"
                      style={headStyle}
                    >
                      <div>
                        {item && item?.user && item?.user?.[0]?.case_id ? (
                          <Link
                            to={`/lead-details/${item?.user?.[0]?.case_id}`}
                            className="text-primary"
                          >
                            <OverlayTrigger
                              overlay={
                                <Tooltip placement="left">
                                  <div className="fs-1 ">Lead Details</div>
                                </Tooltip>
                              }
                            >
                              <span className="text-capitalize">
                                {item?.chat_meta?.user?.first_name}
                              </span>
                            </OverlayTrigger>
                          </Link>
                        ) : (
                          <span className="text-capitalize ">
                            {item?.chat_meta?.user?.first_name}
                          </span>
                        )}
                      </div>
                    </td>
                    <td
                      className="flex-1 m-0 text-black fw-bold"
                      style={headStyle}
                    >
                      {item.direction}
                    </td>
                    <td
                      className="flex-1 m-0 text-black fw-bold"
                      style={headStyle}
                    >
                      {item?.chat_meta?.actor?.type} ||{" "}
                      {item.chat_meta.actor.name}
                    </td>
                    <td
                      className="flex-1 m-0 text-black fw-bold"
                      style={headStyle}
                    >
                      {/* {getFormattedDate(item?.createdAt)} */}
                      {moment(item?.createdAt)
                        .utcOffset("+05:30")
                        .format("D MMMM YYYY, HH:mm:ss")}
                    </td>
                    <td
                      className="text-center cursor-pointer flex-1 m-0 text-primary fw-bold"
                      style={headStyle}
                      onClick={() => handleCall(index, item)}
                    >
                      <OverlayTrigger
                        overlay={
                          <Tooltip style={{ position: "fixed" }}>
                            <div className="p-1 fs-1">Call</div>
                          </Tooltip>
                        }
                      >
                        <div>{isClicked ? <CallCut /> : <CallIcon />}</div>
                      </OverlayTrigger>
                    </td>
                  </tr>
                );
              })
            ) : tableData.length === 0 && isLoading === false ? (
              <div className="w-100 d-flex justify-content-center border bg-white">
                <h3 className="p-3 ">Data is not Available</h3>
                <span>
                  <NoData />
                </span>
              </div>
            ) : (
              ""
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default CustomerChatTable;
